export default __webpack_public_path__ + "static/hexagon_b.c84205fe79d8d201624451c50f285003.png";